import { mixpanel } from '@fiverr-private/obs';

export const sendMixpanel = ({ type, ...params }) =>
    mixpanel.track(type, params);
